export class WorkspaceTaskClient {
  constructor() {
    this.pollIntervalMs = 1000
    this.defaultTimeoutMs = 300000
  }

  async wait(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms))
  }

  async pollTask({ request, workspaceId, taskId, timeoutMs = this.defaultTimeoutMs }) {
    const deadline = Date.now() + timeoutMs

    while (Date.now() < deadline) {
      const response = await request(`/workspaces/${workspaceId}/tasks/${taskId}`)

      if (response.status === 202) {
        await this.wait(this.pollIntervalMs)
        continue
      }

      if (!response.ok) {
        throw new Error(response.data.message || response.data.error || `HTTP ${response.status}`)
      }

      if (response.data.status === 'failed') {
        throw new Error(response.data.error || 'Task failed')
      }

      return response.data.result ?? response.data
    }

    throw new Error('Operation timed out')
  }

  async resolveTaskResponse({ request, workspaceId, response, timeoutMs = this.defaultTimeoutMs }) {
    if (response.status === 202 && response.data?.taskId) {
      return this.pollTask({
        request,
        workspaceId,
        taskId: response.data.taskId,
        timeoutMs,
      })
    }

    if (!response.ok) {
      throw new Error(response.data.message || response.data.error || `HTTP ${response.status}`)
    }

    return response.data
  }
}

export const appWorkspaceTaskClient = new WorkspaceTaskClient()
